/* Lavender Farm Simulator — clearer farm clock.
   Display-only: renames speeds, shows running/paused (and why), greys out the speed arrows at the ends.
   Never changes the saved game. Exits on every page without the simulator. */
(function () {
  'use strict';
  if (window.__gllfSimClock) return;
  var NAMES = { manual: 'Paused', realtime: 'Real-time', relaxed: '1× speed', standard: '2× speed', fast: '4× speed' };
  var ORDER = ['manual', 'realtime', 'relaxed', 'standard', 'fast'];
  function start(root, A) {
    window.__gllfSimClock = true;
    function state() { try { return (A.state() || {}).time || {}; } catch (e) { return {}; } }
    function why(t) {
      if (t.mode === 'manual') return 'manual mode';
      if (document.hidden) return 'tab in background';
      if (root.querySelector('#lfg-modal:not([hidden]),[data-comm-drawer]:not([hidden])')) return 'decision open';
      if (t.paused) return 'paused by you';
      return '';
    }

    /* Frost notice in Farm Time Control: it reports the coldest night of the 7-day outlook,
       so name that day instead of implying it is today. */
    var WD = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function frostInfo(t) {
      var f = t.forecast || [], R = window.LFG_FROST_RULES;
      if (!f.length || !R || !R.worst) return null;
      var w = R.worst(f); if (!w || !w.active) return null;
      var idx = -1;
      f.forEach(function (d, i) { if (idx < 0 && Math.round(+d.low) === Math.round(+w.lowF)) idx = i; });
      if (idx < 0) return null;
      var d = new Date(String(f[idx].date || '') + 'T12:00:00Z'); if (isNaN(d)) return null;
      var ahead = idx - (+t.day || 0);
      var when = ahead === 0 ? 'Tonight' : ahead === 1 ? 'Tomorrow night' : ahead > 1 ? 'In ' + ahead + ' days' : 'Earlier this week';
      return { idx: idx, label: WD[d.getUTCDay()] + ', ' + MO[d.getUTCMonth()] + ' ' + d.getUTCDate(), day: WD[d.getUTCDay()], when: when, key: f[idx].date + '|' + t.day };
    }
    function patchFrost(t) {
      var panel = root.querySelector('[data-time-panel]'); if (!panel || panel.hidden) return;
      var info = frostInfo(t);
      panel.querySelectorAll('.lfg-frost-notice').forEach(function (n) {
        if (!info || n.getAttribute('data-gllf-frost') === info.key) return;
        n.setAttribute('data-gllf-frost', info.key);
        var sm = n.querySelector('header small'); if (sm) sm.textContent = 'Frost ahead · ' + info.label + ' · ' + info.when;
        var pp = n.querySelector('p'); if (pp) pp.textContent = pp.textContent.replace(/^Farm-weather record:/, info.day + '’s farm-weather record:');
      });
      var cards = panel.querySelectorAll('.lfg-week-forecast > article');
      cards.forEach(function (c, i) { c.classList.toggle('gllf-frost-day', !!info && i === info.idx); });
    }

    /* New farms start at 2x speed so the clock visibly moves. Runs once per browser, and only
       for a farm that has not started yet; a player's own speed choice is never overridden. */
    function defaultSpeed(t) {
      var KEY = 'gllf_sim_clock_default_v1';
      try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }
      var st = A.state() || {};
      var fresh = t.mode === 'realtime' && !(+st.xp) && !(t.activityLog || []).length && !(+t.manualMinutes);
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      if (!fresh) return;
      var sel = Array.prototype.find.call(root.querySelectorAll('select'), function (x) { return Array.prototype.some.call(x.options, function (o) { return o.value === 'standard'; }); });
      if (sel) { sel.value = 'standard'; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    /* Hide the toolbar date/time until the saved farm has painted it (no "Apr 1, 6:00 AM" flash). */
    function fmt(min) { min = Math.floor(+min || 0); var h = Math.floor(min / 60) % 24, m = min % 60; return ((h % 12) || 12) + ':' + (m < 10 ? '0' : '') + m + ' ' + (h < 12 ? 'AM' : 'PM'); }
    function checkReady(t) {
      if (root.hasAttribute('data-gllf-clock-ready')) return;
      var v = root.querySelector('[data-pulse-time-value]');
      if (!v || v.textContent.trim() === fmt(t.minute)) root.setAttribute('data-gllf-clock-ready', '');
    }
    setTimeout(function () { root.setAttribute('data-gllf-clock-ready', ''); }, 6000);
    function paint() {
      var t = state(); if (!t.mode) return;
      checkReady(t); patchFrost(t);
      var reason = why(t), txt = reason ? 'Paused' : (NAMES[t.mode] || t.mode);
      root.querySelectorAll('[data-pulse-time-mode-label]').forEach(function (l) {
        var s = l.querySelector('.lfg-try-state');
        if (!s || s.getAttribute('data-v') !== txt + reason) {
          l.innerHTML = '<span class="lfg-try-state' + (reason ? ' is-paused' : '') + '" data-v="' + txt + reason + '"><i class="lfg-try-dot" aria-hidden="true"></i><span>' + txt + '</span></span>';
        }
        var g = l.closest('.lfg-pulse-time-stepper');
        if (g) g.title = reason ? 'Farm clock paused: ' + reason : 'Farm clock running at ' + NAMES[t.mode];
      });
      root.querySelectorAll('select option').forEach(function (o) {
        if (!NAMES[o.value]) return;
        var n = NAMES[o.value] + (o.value === 'manual' ? ' (moves only when I act)' : '');
        if (o.text !== n) o.text = n;
      });
      var i = ORDER.indexOf(t.mode);
      root.querySelectorAll('[data-pulse-time-step="-1"]').forEach(function (b) { b.disabled = i <= 0; b.setAttribute('aria-label', 'Slower farm clock'); });
      root.querySelectorAll('[data-pulse-time-step="1"]').forEach(function (b) { b.disabled = i >= ORDER.length - 1; b.setAttribute('aria-label', 'Faster farm clock'); });
      var fc = root.querySelector('[data-farm-clock]');
      if (fc) {
        var p = fc.querySelector('.lfg-try-hero-pause');
        if (reason) { if (!p) { p = document.createElement('span'); p.className = 'lfg-try-hero-pause'; p.setAttribute('role', 'status'); fc.appendChild(p); } var pt = '⏸ Paused · ' + reason; if (p.textContent !== pt) p.textContent = pt; }
        else if (p) p.remove();
      }
    }
    try { defaultSpeed(state()); } catch (e) {}
    setInterval(paint, 250); paint();
    /* repaint in the same frame the game redraws the clock, so its own label ("Relaxed") never shows between our paints */
    var painting = false;
    new MutationObserver(function () { if (painting) return; painting = true; try { paint(); } catch (e) {} painting = false; })
      .observe(root, { childList: true, subtree: true, characterData: true });
    document.addEventListener('visibilitychange', paint);
  }
  var tries = 0;
  (function wait() {
    var root = document.getElementById('lfg-simulator-root');
    if (!root && document.readyState === 'complete') return;
    if (root && root._lfg && typeof root._lfg.state === 'function') return start(root, root._lfg);
    if (++tries < 240) setTimeout(wait, 250);
  })();
})();
